import * as tslib_1 from "tslib";
import HLabel from "../../../common/components/label.vue";
import { labelText } from "../../../schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let CreatedDeptId = class CreatedDeptId extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], CreatedDeptId.prototype, "control", void 0);
CreatedDeptId = tslib_1.__decorate([
    Component({
        name: 'CreatedDeptId',
        components: {
            HLabel: HLabel
        }
    })
], CreatedDeptId);
export default CreatedDeptId;
